<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/stujapcollect">日语汇总</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>课程统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="时间">
          <el-date-picker
            v-model="query.time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="yearSearch()"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="yearSearch()">查询</el-button>
        </el-form-item>
      </el-form>

      <div style="height: 20px"></div>
      <el-card class="box-card collectCard" shadow="always">
        <div class="clearfix" slot="header">
          <span>课程缴费情况汇总</span>
        </div>
        <div class="index-card" style="height: auto">
          <el-table :data="list" show-summary stripe style="width: 100%">
            <el-table-column prop="name" label="课程名称"></el-table-column>
            <el-table-column
              prop="price"
              label="课程价格"
              sortable
            ></el-table-column>
            <el-table-column
              prop="totalCount"
              label="缴费人数"
              sortable
            ></el-table-column>
            <el-table-column
              prop="totalAmount"
              label="缴费总额"
            ></el-table-column>
          </el-table>
          <div style="height: 115px"></div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import user from "@/plugins/user.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {}, //对象
      loading: false,
      userIsAdmain: user.isAdmin(),
      list: [], //数据详情
      adviserList: [],
      marketList: [],
      year: "",
    };
  },
  methods: {
    //获取学校统计，地区统计
    getCollect() {
      var _this = this;
      // _this.query.year = this.year;
      //柱状图
      var link2 = url.getJapCollect("GetCourse");
      $.get(link2, _this.query, (data) => {
        _this.list = data;
      });
    },
    //月份选择
    yearSearch() {
      if (this.query.time) {
        this.query.start = this.query.time[0];
        this.query.end = this.query.time[1];
      } else {
        this.query.start = "";
        this.query.end = "";
      }
      this.getCollect();
    },
  },
  created() {},
  mounted() {
    var _this = this;
    this.getCollect();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
